module.exports = __webpack_public_path__ + "img/fb_logo.955ffa15.png";